import { render, staticRenderFns } from "./teamtree.vue?vue&type=template&id=db18d2b6&scoped=true"
import script from "./teamtree.vue?vue&type=script&lang=js"
export * from "./teamtree.vue?vue&type=script&lang=js"
import style0 from "./teamtree.vue?vue&type=style&index=0&id=db18d2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db18d2b6",
  null
  
)

export default component.exports